import './ui.css';

interface Props {
  size?: number;
  inline?: boolean;
  label?: string;
}

export function Spinner({ size = 14, inline = false, label }: Props) {
  return (
    <span className={`spinner-wrap ${inline ? 'inline' : ''}`}>
      <span
        className="spinner"
        style={{ width: size, height: size, borderWidth: Math.max(1.5, size / 8) }}
      />
      {label && <span className="spinner-label">{label}</span>}
    </span>
  );
}

